'use client';

export { GamesGrid } from './components/GamesGridDynamic';
export { GamesGridStatic } from './components/GamesGridStatic';
